<template>
  <q-page padding>
    <div class="row q-gutter-sm">
      <div class="col-12">
        <p class="text-h6 text-weight-bold text-brand-5 texto-titulo">
          Relatório de Cautela
        </p>
      </div>
    </div>
    <div
      class="row col-12 q-mt-md q-gutter-sm text-weight-bold text-brand-5 items-center"
    >
      <div class="col-md-2 col-xs-6">
        <div class="texto-titulo-input">Unidade</div>
        <lista-unidades-select v-model="unidade"></lista-unidades-select>
      </div>
      <div class="col-md-3 col-xs-5">
        <div class="texto-titulo-input">Selecione o Funcionário</div>
        <SelecaoFuncionario
          @emitirFuncionario="receberFuncionario"
          :deletado="usuarioDeletado"
          :resetar="resetarFuncionario"
          :vendor-id="unidade?.id"
        />
      </div>
      <div class="col-md-2 col-xs-6">
        <div class="texto-titulo-input">Data Inicial</div>
        <q-input
          class="input"
          v-model="data.dataInicio"
          dense
          outlined
          placeholder="DD/MM/AAAA"
          mask="##/##/####"
        >
          <template v-slot:append>
            <q-icon name="event" class="cursor-pointer">
              <q-popup-proxy
                cover
                transition-show="scale"
                transition-hide="scale"
              >
                <q-date
                  v-model="data.dataInicio"
                  :locale="myLocale"
                  mask="DD/MM/YYYY"
                >
                  <div class="row items-center justify-end">
                    <q-btn v-close-popup label="Fechar" color="primary" flat />
                  </div>
                </q-date>
              </q-popup-proxy>
            </q-icon>
          </template>
        </q-input>
      </div>
      <div class="col-md-2 col-xs-5">
        <div class="texto-titulo-input">Data Final</div>
        <q-input
          class="input"
          dense
          v-model="data.dataTermino"
          outlined
          placeholder="DD/MM/AAAA"
          mask="##/##/####"
        >
          <template v-slot:append>
            <q-icon name="event" class="cursor-pointer">
              <q-popup-proxy
                cover
                transition-show="scale"
                transition-hide="scale"
              >
                <q-date
                  v-model="data.dataTermino"
                  :locale="myLocale"
                  mask="DD/MM/YYYY"
                >
                  <div class="row items-center justify-end">
                    <q-btn v-close-popup label="Fechar" color="primary" flat />
                  </div>
                </q-date>
              </q-popup-proxy>
            </q-icon>
          </template>
        </q-input>
      </div>
      <div>
        <p></p>
        <q-btn
          class="q-mt-xs btn"
          label="Filtrar"
          icon="filter_alt"
          @click="filtrarCautela"
          color="primary"
          no-caps
        />
      </div>
    </div>
    <div
      class="q-mt-sm q-mb-sm text-weight-bold text-brand-5 texto-titulo-input"
    >
      <q-toggle
        @click="filtrarCautela"
        label="Não devolvidos"
        v-model="emAberto"
        color="green"
      />
      <q-toggle
        @click="filtrarCautela"
        label="Todas Unidades"
        v-model="porUnidade"
        color="green"
      />
      <q-toggle
        label="Usuarios Deletados"
        v-model="usuarioDeletado"
        color="green"
      />
    </div>
    <div class="q-mt-xl">
      <UploadCautelaAssinada
        :funcionario="funcionario"
        :tipoAnexo="'fichaCautela'"
      />
    </div>
    <div class="row col-12 q-mt-xl desktop">
      <div class="row col-12 q-mb-sm">
        <div class="text-brand-5 text-weight-bold titulo-tabela">
          Ficha de Responsabilidade
        </div>
      </div>
      <div class="row col-12 q-mt-md">
        <q-btn
          label="Imprimir"
          :disable="funcionario.matricula == undefined"
          class="btn"
          color="primary"
          @click="imprimir"
          no-caps
          icon="print"
        />
      </div>
    </div>
    <div class="q-mt-lg desktop">
      <div class="base">
        <div class="row headerBase">
          <img
            v-if="
              $store.state.autenticacao.logo &&
              $store.state.autenticacao.logo.logoImpressao
            "
            :src="$store.state.autenticacao.logo.logoImpressao"
            alt="Multpex Logo"
            class="logo q-pl-sm"
          />

          <img
            v-else
            src="../../../assets/MULTPEX_VETOR.png"
            alt="Multpex Logo"
            class="logo q-pl-sm"
          />
          <div
            class="text-h6 texto-titulo-ficha row col justify-center text-bold q-pa-md"
            style="word-wrap: break-word"
          >
            {{
              dadosCustumizados
                ? dadosCustumizados.titulo
                : "FICHA DE RESPONSABILIDADE"
            }}
          </div>
        </div>
        <div class="row justify-center texto-subtulo-ficha subHeader">
          {{ dadosCustumizados ? dadosCustumizados.subtitulo : "" }}
        </div>

        <div class="row q-pl-sm justify-center texto-dizeres-ficha descricao">
          {{ dadosCustumizados ? dadosCustumizados.dizeres : "" }}
        </div>
        <div class="row data1 border-botom">
          <div class="q-pl-sm nome text-bold row items-center">
            <p>NOME: {{ funcionario ? funcionario.nome : "" }}</p>
          </div>
          <div class="q-pl-sm função text-bold row items-center">
            <p>MATRICULA: {{ funcionario ? funcionario.id : "" }}</p>
          </div>
        </div>
        <div class="row data1">
          <div
            style="width: 35%"
            class="q-pl-sm borderleft text-bold row items-center"
          >
            <p>
              DATA DE ADMISSÃO:
              {{
                funcionarioDado?.dataAdmissao
                  ?.split(" ")[0]
                  ?.split("-")
                  ?.reverse()
                  ?.join("/")
              }}
            </p>
          </div>
          <div style="width: 25%" class="q-pl-sm text-bold row items-center">
            <p>CARGO: {{ funcionarioDado?.cargo }}</p>
          </div>
          <div class="q-pl-sm col função text-bold row items-center">
            <p>GHE: {{ funcionarioDado?.funcao }}</p>
          </div>
        </div>
        <div class="row data2 border-botom">
          <div class="row column DESCRIÇÃODOMATERIAL">
            <p style="width: 50%" class="row codigo justify-center text-bold">
              CODIGO
            </p>
            <p class="row justify-center text-bold borderleft">
              DESCRIÇÃO DO MATERIAL
            </p>
          </div>
          <div class="column col ENTREGA">
            <p class="row justify-center border-botom borderleft text-bold">
              ENTREGA
            </p>
            <div class="row">
              <div class="table1 borderleft">
                <p class="text text-bold">Nº DO PATRIMÔNIO</p>
              </div>

              <div class="table2 borderleft">
                <p class="text text-bold">ASSINATURA</p>
              </div>
              <div class="table3 borderleft">
                <p class="text text-bold">UNIDADE</p>
              </div>
              <div class="table4 borderleft">
                <p class="text text-bold">DATA</p>
              </div>
            </div>
          </div>
          <div class="column DEVOLUÇÃO desktop">
            <p class="row justify-center border-botom text-bold">DEVOLUÇÃO</p>
            <div style="height: 65%" class="row">
              <div class="secondTable1 borderleft">
                <p class="text text-bold">Nº DO PATRIMÔNIO</p>
              </div>
              <div class="secondTable2 borderleft">
                <p class="text text-bold">ASSINATURA</p>
              </div>
              <div class="secondTable3 borderleft column">
                <p class="text text-bold">DATA ENTREGA</p>
              </div>
              <div class="secondTable4 column">
                <p class="text text-bold">UNIDADE</p>
              </div>
            </div>
          </div>
        </div>

        <div
          class="data3 row border-botom"
          v-for="(tabela, index) in dadosTabela"
          :key="index"
        >
          <div class="row DESCRIÇÃODOMATERIAL borderleft">
            <p style="width: 50%" class="row justify-center">
              {{ tabela ? tabela.codigo : "" }}
            </p>

            <p style="width: 50%" class="row justify-center codigo3">
              {{ tabela ? tabela.descricao : "" }}
            </p>
          </div>
          <div class="ENTREGA borderleft">
            <div class="row" style="height: 100%">
              <div class="table1 borderleft column">
                <p style="width: 100%" class="text">
                  {{ tabela ? tabela.patrimonio : "" }}
                </p>
              </div>

              <div class="table2 borderleft column">
                <img
                  v-if="
                    tabela.assinaturaRetirada == 'assinatura' ||
                    tabela.assinaturaRetirada == 'biometria'
                  "
                  width="90px"
                  heigth="65px"
                  class="biometria"
                  alt=""
                  fit="contain"
                  :src="tabela.conteudoAssinaturaRetirada"
                />

                <p
                  v-else-if="tabela.assinaturaRetirada != null"
                  style="text-align: center"
                >
                  Assinado Eletronicamente
                </p>
              </div>
              <div class="table3 column">
                <p style="width: 100%" class="text">
                  {{ tabela ? tabela.unidadeRetirada : "" }}
                </p>
              </div>
              <div class="column table4 codigo2">
                <p>
                  {{
                    tabela && tabela.dataRetirada
                      ? tabela.dataRetirada
                          .split(" ")[0]
                          .split("-")
                          .reverse()
                          .join("/")
                      : ""
                  }}
                </p>
              </div>
            </div>
          </div>
          <div class="DEVOLUÇÃO">
            <div style="height: 100%" class="row">
              <div class="table1 borderleft column">
                <p style="width: 100%" class="text">
                  {{ tabela ? tabela.patrimonio : "" }}
                </p>
              </div>
              <div class="secondTable2 borderleft column">
                <q-img
                  v-if="
                    tabela.assinaturaDevolucao == 'assinatura' ||
                    tabela.assinaturaDevolucao == 'biometria'
                  "
                  width="90px"
                  heigth="65px"
                  class="biometria"
                  :src="tabela.conteudoAssinaturaDevolucao"
                  alt=""
                  fit="contain"
                />

                <p
                  v-else-if="tabela.assinaturaDevolucao != null"
                  style="text-align: center"
                  class="text"
                >
                  Assinado Eletronicamente
                </p>
              </div>
              <div style="border-right: 1px solid black" class="column table4">
                <p>
                  {{
                    tabela && tabela.dataDevolucao
                      ? tabela.dataDevolucao
                          .split(" ")[0]
                          .split("-")
                          .reverse()
                          .join("/")
                      : ""
                  }}
                </p>
              </div>
              <div class="secondTable3 column">
                <p style="width: 100%" class="text">
                  {{ tabela ? tabela.unidadeDevolucao : "" }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </q-page>
</template>

<script>
import { ref, watch } from "vue";
import { useQuasar } from "quasar";
import { useStore } from "vuex";
import ListaUnidadesSelect from "../../organizacional/unidade/component/ListaUnidadesSelect.vue";

import SelecaoFuncionario from "../components/SelecaoFuncionario.vue";
import UploadCautelaAssinada from "../components/UploadDocumentos.vue";
import { useRouter } from "vue-router";

export default {
  components: {
    ListaUnidadesSelect,
    SelecaoFuncionario,
    UploadCautelaAssinada,
  },
  setup() {
    const quasar = useQuasar();
    const router = useRouter();
    const emAberto = ref(false);
    const usuarioDeletado = ref(false);
    const store = useStore();

    const dadosCustumizados = ref();
    const resetarFuncionario = ref(0);
    const data = ref({
      dataInicio: "01/01/2001",
      dataTermino: new Date().toLocaleDateString("pt-BR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      }),
    });
    const funcionario = ref("");
    const funcionarioDado = ref("");
    const dadosTabela = ref("");
    const unidade = ref("");
    let porUnidade = ref(true);
    let mobile = ref(false);

    if (quasar.platform.is.mobile) {
      mobile.value = true;
    }

    store.dispatch("pdt/hiddenHeader", true);

    const filtrarCautela = async () => {
      if (funcionario.value.matricula === undefined) {
        dadosCustumizados.value = "";
        dadosTabela.value = "";
        return;
      }
      try {
        const response = await store.dispatch("ferramentaria/getCautela", {
          unidadeId: porUnidade.value ? undefined : unidade.value?.id,
          unidadeModeloId: store.state.org.unidadeData.id,
          funcionarioId: funcionario.value.matricula,
          emAberto: emAberto.value == true ? "1" : undefined,
          deletado: usuarioDeletado.value ? true : undefined,
          dataInicial: data.value.dataInicio
            ? data.value.dataInicio.split("/").reverse().join("-")
            : data.value.dataInicio,
          dataFinal: data.value.dataTermino
            ? data.value.dataTermino
                .split(",")[0]
                .split("/")
                .reverse()
                .join("-")
            : data.value.dataTermino,
        });
        dadosCustumizados.value = response.data.resultado.mensagem.fichaCautela;
        funcionarioDado.value = response.data.resultado.mensagem.funcionario;
        dadosTabela.value =
          response.data.resultado.mensagem.emprestimoCollection;
        if (mobile.value) {
          setTimeout(() => {
            imprimir();
          }, 2000);
        }
      } catch (error) {
        quasar.notify({
          message: error.response.data.erro.mensagem,
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        dadosTabela.value = [];
      }
    };

    const receberFuncionario = (value) => {
      funcionario.value = value;

      filtrarCautela();
    };

    watch(
      () => store.state.org.unidadeData,
      () => {
        if (store.state.org.unidadeData == null) {
          return;
        }
        unidade.value = store.state.org.unidadeData;
      }
    );

    const imprimir = async () => {
      const routeData = router.resolve({
        name: "ferramentaria-impressao-cautela",
        params: {
          dados: JSON.stringify({
            ...funcionario.value,
            dataInicio: data.value.dataInicio,
            dataTermino: data.value.dataTermino,
            emAberto: emAberto.value == true ? "1" : undefined,
            deletado: usuarioDeletado.value ? true : undefined,
            unidadeId: store.state.org.unidadeData.id,
            unidadeConfiguracao: porUnidade.value
              ? undefined
              : unidade.value?.id,
          }),
        },
      });
      window.open(routeData.href, "_blank");
    };

    const resetarDados = () => {
      resetarFuncionario.value++;
      funcionarioDado.value = "";
      dadosCustumizados.value = "";
    };

    watch(
      () => usuarioDeletado.value,
      () => {
        resetarDados();
      }
    );

    return {
      mobile,
      myLocale: {
        days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
        daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
        months:
          "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
            "_"
          ),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split(
          "_"
        ),
        firstDayOfWeek: 1,
      },
      dadosCustumizados,
      data,
      filtrarCautela,
      receberFuncionario,
      resetarFuncionario,
      funcionario,
      imprimir,

      dadosTabela,
      unidade,
      usuarioDeletado,
      porUnidade,
      emAberto,
      funcionarioDado,
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}

.base {
  border: 1px solid black;
}

.base p {
  margin: 0px;
}

.headerBase {
  border-bottom: 1px solid black;
  display: flex;
  align-items: center;
  height: 86px;
}

.border-botom {
  border-bottom: 1px solid black;
}

.separador {
  height: 5px;
  border-bottom: 1px solid black;
}

.função {
  width: 30%;
  border-left: 1px solid black;
}

.nome {
  width: 60%;
}

.data2 {
  border-top: 1px solid black;
}

.DESCRIÇÃODOMATERIAL {
  width: 35%;
}

.DESCRIÇÃODOMATERIAL p {
  height: 100%;
  align-items: center;
}

.ENTREGA {
  width: 35%;
}

.DEVOLUÇÃO {
  width: 30%;
}

.borderleft {
  border-right: 1px solid black;
}

.codigo2 {
  border-left: 1px solid black;
}

.codigo3 {
  border-left: 1px solid black;
}
.text {
  text-align: center;
  word-wrap: break-word;
}

.table1 {
  display: flex;
  justify-content: center;
  width: 25%;
  align-items: center;
}

.table2 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 25%;
}
.table3 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 25%;
}
.table4 {
  display: flex;
  justify-content: center;
  width: 25%;
  align-items: center;
}

.data3 {
  height: 76px !important;
}

.secondTable1 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 25%;
}

.secondTable2 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 25%;
}

.subHeader {
  border-bottom: 1px solid black;
  font-weight: bolder;
}

.descricao {
  border-bottom: 1px solid black;
  min-height: 56px;
  align-items: center;
}
.secondTable3 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 25%;
  margin: 0 auto;
}
.biometria {
  height: 60px !important;
  width: 90px !important;
  object-fit: contain;
}
.secondTable4 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 25%;
}

.border-top {
  border-top: 1px solid black;
}

.headerBase p {
  width: 79%;
  display: flex;
  justify-content: center;
}

.codigo {
  border-right: 1px solid black;
}

.logo {
  margin-top: 5px;
  height: 50px;
  width: 180px;
}
.titulo-tabela {
  font-size: 18px;
}
@media (max-width: 1000px) {
  .base p {
    font-size: 10px;
    margin: 0px;
    padding: 0px;
  }
}
@media (max-width: 800px) {
  .base p {
    font-size: 8px;
    margin: 0px;
    padding: 0px;
  }
}
@media (max-width: 600px) {
  .logo {
    margin-top: 5px;
    height: 40px;
    width: 120px;
  }
  .texto-titulo {
    font-size: 16px;
  }
  .texto-titulo-input {
    font-size: 12px;
  }
  .input {
    font-size: 12px;
  }
  .btn {
    font-size: 12px;
  }
  .titulo-tabela {
    font-size: 14px;
    margin-bottom: 10px;
    margin-left: 0px;
  }
  .base p {
    font-size: 6px;
    margin: 0px;
    padding: 0px;
  }
  .table1 {
    display: flex;
    justify-content: center;
    width: 26%;
    align-items: center;
  }

  .table2 {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 30%;
  }
  .table3 {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 20%;
  }
  .table4 {
    display: flex;
    justify-content: center;
    width: 20%;
    align-items: center;
  }
  .secondTable1 {
    justify-content: center;
    align-items: center;
    width: 30%;
  }

  .secondTable2 {
    justify-content: center;
    align-items: center;
    width: 50%;
  }

  .secondTable3 {
    justify-content: center;
    align-items: center;
    width: 20%;
    margin: 0 auto;
  }
  .DESCRIÇÃODOMATERIAL {
    width: 10%;
  }

  .ENTREGA {
    width: 50%;
  }

  .DEVOLUÇÃO {
    width: 40%;
  }
  .biometria {
    height: 25px !important;
    width: 35px !important;
    object-fit: contain;
  }
  .texto-titulo-ficha {
    font-size: 10px;
  }
  .texto-subtulo-ficha {
    font-size: 9px;
  }
  .texto-dizeres-ficha {
    font-size: 9px;
  }
  .desktop {
    display: none;
  }
}
</style>
